import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Flex, Text } from 'onefaceui-react-components';
import { push } from 'connected-react-router';
import { v4 as uuid } from 'uuid';

import UserIcon from 'static/images/user.svg';
import EditIcon from 'static/images/pencil.svg';
import EquipmentIcon from 'static/images/equipment.svg';
import { getResourceTo } from 'react/utils/utils';

export const Assignments = ({
  type = 'driver',
  assignments,
  extractor,
  onClickOnEdit,
  disableEditAssign,
  disableEditItem
}) => {
  const dispatch = useDispatch();

  const iconsByType = {
    driver: UserIcon,
    equipment: EquipmentIcon,
    tag: EquipmentIcon
  };

  const titleByType = {
    driver: getResourceTo('Driver'),
    equipment: getResourceTo('Equipment'),
    tag: getResourceTo('Tag')
  };

  const onClickAssignmentItem = (item) => {
    const itemId = item[type]?.id;

    const urls = {
      equipment: `/Equipment/edit/${itemId}`,
      driver: `/Driver/edit/${itemId}`,
      tag: `/Tag/edit/${itemId}`
    };

    if (itemId && urls[type]) {
      dispatch(push(urls[type]));
    }
  };

  return (
    <Flex
      className="assignments-list"
      data-testid={`assignments-${type}`}
      flexDirection="column"
    >
      <Flex alignItems="center" gap={2}>
        <img
          src={iconsByType[type]}
          data-testid="assignments-icon"
          alt={`${type} Icon`}
        />
        <Text weight="bold" size="xs" dataTestId="assignments-type-and-count">
          {titleByType[type]} ({assignments.length})
        </Text>
        {!disableEditAssign && (
          <button
            type="button"
            className="assign-button"
            data-testid={`${type}-assignment-edit`}
            onClick={onClickOnEdit}
          >
            <img src={EditIcon} alt="Edit Icon" />
          </button>
        )}
      </Flex>
      <Flex alignItems="flex-end" gap={4}>
        <Flex flexDirection="column" gap={2}>
          {[...assignments].slice(0, 2)?.map((item) => (
            <Text
              className={`item ${!disableEditItem ? 'editable' : ''}`}
              key={uuid()}
              type="primary"
              size="xs"
              overflow="ellipsis"
              dataTestId="assignment-extractor"
              onClick={!disableEditItem ? () => onClickAssignmentItem(item) : null}
            >
              {extractor(item)}
            </Text>
          ))}
        </Flex>
        {assignments.length > 2 && (
          <button
            type="button"
            data-testid="button-other-assignments"
            className="assign-button"
            onClick={onClickOnEdit}
          >
            ...
          </button>
        )}
      </Flex>
    </Flex>
  );
};

Assignments.propTypes = {
  type: PropTypes.string.isRequired,
  assignments: PropTypes.array,
  extractor: PropTypes.func.isRequired,
  onClickOnEdit: PropTypes.func.isRequired,
  disableEditAssign: PropTypes.bool,
  disableEditItem: PropTypes.bool
};

Assignments.defaultProps = {
  assignments: [],
  disableEditAssign: false,
  disableEditItem: false
};

export default memo(Assignments);
